module.exports = __webpack_public_path__ + "img/instruction5.573a9ed1.jpg";